import { CalibrationItem } from "../routes/customer/_customer_id/field/_field_id/result-set/calibrate/Calibration.types";
import { get } from "./AureaApi";
import { getUrl } from "../getUrl";
import { useAuth } from "./auth";

export type ResultSetCalibration = {
  model_type: "linear";
  source_result_set_id: string;
  calibration_measurement_set_id: string;
  slope: number;
  intercept: number;
};

export type CalibrationMeasurement = {
  plot_id: number;
  manual_count: number;
};

export type CalibrationStatus = "in_progress" | "succeeded" | "failed";

export type CalibrationError = {
  code: string;
  message: string;
  detail?: Record<string, unknown> | null;
};

export type CalibrationMeasurementSet = {
  id: string;
  source_result_set_id: string;
  version: number;
  measurements: CalibrationMeasurement[];
  created_at: string;
  status?: CalibrationStatus | null;
  error?: CalibrationError | null;
};

export type YieldEstimate = {
  id: string;
  result_set_id: string;
  calibration_measurement_set_id: string;
  average_weight_g: number;
  yield_estimate_kg: number;
  yield_estimate_kg_per_ha: number;
  yield_estimate_kg_lower: number | null;
  yield_estimate_kg_upper: number | null;
  yield_estimate_kg_per_ha_lower: number | null;
  yield_estimate_kg_per_ha_upper: number | null;
  created_at: string;
  updated_at: string;
};

export async function getCalibrationMeasurementSet(
  calibrationMeasurementSetId: string,
): Promise<CalibrationMeasurementSet> {
  return get<CalibrationMeasurementSet>(
    `/v1/calibration_measurement_set/${calibrationMeasurementSetId}`,
  );
}

export async function listCalibrationMeasurementSets(
  sourceResultSetId: string,
): Promise<CalibrationMeasurementSet[]> {
  return get<CalibrationMeasurementSet[]>(
    `/v1/result_set/${sourceResultSetId}/calibration_measurement_set`,
  );
}

export async function createCalibrationSet(
  calibrationSet: Pick<CalibrationItem, "plotId" | "manualCount">[],
  resultSetId: string | undefined,
  averageWeight: number,
): Promise<Response | null> {
  const token = await useAuth.getState().getToken();
  if (!token) {
    return null;
  }
  return await fetch(getUrl(`/v1/result_set/${resultSetId}/calibration_set`), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      measurements: calibrationSet.map((item) => ({
        plot_id: item.plotId,
        manual_count: item.manualCount,
      })),
      average_weight_g: averageWeight,
    }),
  });
}

export async function getYieldEstimate(
  resultSetId: string,
): Promise<YieldEstimate> {
  return get<YieldEstimate>(`/v1/result_set/${resultSetId}/yield_estimate`);
}
